import type { Template } from "@/types";

export const PO_04_H1_V3: Template[] = [
{
    id: "po-04-h1v3-01",
    name: "PO 01 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 40, y: 257, width: 198, height: 338, rotation: 0, imageRotation: 0 },
            { id: "2", x: 246, y: 257, width: 441, height: 338, rotation: 0, imageRotation: 0 },
            { id: "3", x: 695, y: 257, width: 198, height: 338, rotation: 0, imageRotation: 0 },
            { id: "4", x: 901, y: 257, width: 197, height: 338, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-04-h1v3-02",
    name: "PO 02 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 93, y: 105, width: 381, height: 644, rotation: 0, imageRotation: 0 },
        { id: "2", x: 661, y: 105, width: 382, height: 322, rotation: 0, imageRotation: 0 },
        { id: "3", x: 661, y: 435, width: 187, height: 313, rotation: 0, imageRotation: 0 },
        { id: "4", x: 856, y: 435, width: 187, height: 313, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h1v3-03",
    name: "PO 03 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 32, y: 0, width: 504, height: 854, rotation: 0, imageRotation: 0 },
        { id: "2", x: 632, y: 85, width: 430, height: 322, rotation: 0, imageRotation: 0 },
        { id: "3", x: 632, y: 415, width: 211, height: 353, rotation: 0, imageRotation: 0 },
        { id: "4", x: 851, y: 415, width: 211, height: 353, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h1v3-04",
    name: "PO 04 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 38, y: 257, width: 445, height: 338, rotation: 0, imageRotation: 0 },
        { id: "2", x: 491, y: 257, width: 197, height: 338, rotation: 0, imageRotation: 0 },
        { id: "3", x: 696, y: 257, width: 197, height: 338, rotation: 0, imageRotation: 0 },
        { id: "4", x: 901, y: 257, width: 197, height: 338, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h1v3-05",
    name: "PO 05 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 89, y: 453, width: 389, height: 282, rotation: 0, imageRotation: 0 },       
        { id: "2", x: 89, y: 117, width: 191, height: 328, rotation: 0, imageRotation: 0 },
        { id: "3", x: 288, y: 117, width: 190, height: 328, rotation: 0, imageRotation: 0 },
        { id: "4", x: 642, y: 70, width: 418, height: 713, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h1v3-06",
    name: "PO 06 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_06.png",
    size: [1136, 854],
    style: {},
    slots: [     
        { id: "1", x: 44, y: 291, width: 155, height: 271, rotation: 0, imageRotation: 0 },
        { id: "2", x: 207, y: 291, width: 154, height: 271, rotation: 0, imageRotation: 0 },
        { id: "3", x: 369, y: 291, width: 154, height: 271, rotation: 0, imageRotation: 0 },
        { id: "4", x: 612, y: 246, width: 480, height: 361, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h1v3-07",
    name: "PO 07 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 36, y: 257, width: 196, height: 332, rotation: 0, imageRotation: 0 },
        { id: "2", x: 240, y: 146, width: 294, height: 221, rotation: 0, imageRotation: 0 },
        { id: "3", x: 240, y: 375, width: 196, height: 332, rotation: 0, imageRotation: 0 },
        { id: "4", x: 630, y: 0, width: 506, height: 854, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h1v3-08",
    name: "PO 08 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 80, y: 193, width: 141, height: 229, rotation: 0, imageRotation: 0 },
        { id: "2", x: 80, y: 430, width: 141, height: 229, rotation: 0, imageRotation: 0 },
        { id: "3", x: 229, y: 193, width: 284, height: 466, rotation: 0, imageRotation: 0 },
        { id: "4", x: 521, y: 193, width: 536, height: 466, rotation: 0, imageRotation: 0 } 
    ],
},

{
    id: "po-04-h1v3-09",
    name: "PO 09 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_09.png",
    size: [1136, 854],
    style: {},
    slots: [     
        { id: "1", x: 40, y: 257, width: 196, height: 338, rotation: 0, imageRotation: 0 },
        { id: "2", x: 244, y: 257, width: 196, height: 338, rotation: 0, imageRotation: 0 },
        { id: "3", x: 448, y: 257, width: 196, height: 338, rotation: 0, imageRotation: 0 },
        { id: "4", x: 652, y: 257, width: 446, height: 338, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-04-h1v3-10",
    name: "PO 10 - H1V3",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-04-h1_v3_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 56, y: 64, width: 875, height: 725, rotation: 0, imageRotation: 0 },
        { id: "2", x: 939, y: 64, width: 141, height: 237, rotation: 0, imageRotation: 0 },
        { id: "3", x: 939, y: 309, width: 141, height: 236, rotation: 0, imageRotation: 0 },
        { id: "4", x: 939, y: 553, width: 141, height: 236, rotation: 0, imageRotation: 0 }
    ],
}
];